import {SupportedLanguages} from '../../types/SupportedLanguages';

export const formatEuro = (value: number): string => {
  const formattedNumber = value.toLocaleString('de-DE');
  return `€ ${formattedNumber}`;
};

/**
 * Formats a number as a string with localized thousand separators.
 * @param num - The number to format.
 * @param language - The current language ('en' or 'de').
 * @returns The formatted number string.
 * @example
 * formatNumber(1234567, 'de'); // returns "1.234.567"
 * formatNumber(1234567, 'en'); // returns "1,234,567"
 */
export const formatNumber = (num: number, language: SupportedLanguages): string => {
  const locale = language === 'de' ? 'de-DE' : 'en-US';
  return num.toLocaleString(locale);
};
